"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _utilityClassNames = require("@emcm-ui/utility-class-names");

var _utilityClassNames2 = _interopRequireDefault(_utilityClassNames);

var _GlobalHeader = require("./GlobalHeader");

var _GlobalHeader2 = _interopRequireDefault(_GlobalHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(domNode, rehydrateChildren) {
    var getClassName, leftItemsNode, rightItemsNode, leftItems, rightItems, rehydratedProps;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            getClassName = (0, _utilityClassNames2.default)("GlobalHeader");
            leftItemsNode = domNode.querySelector("." + getClassName({
              descendantName: "leftItems"
            }));
            rightItemsNode = domNode.querySelector("." + getClassName({
              descendantName: "rightItems"
            }));

            if (!leftItemsNode) {
              _context.next = 9;
              break;
            }

            _context.next = 6;
            return rehydrateChildren(leftItemsNode);

          case 6:
            _context.t0 = _context.sent;
            _context.next = 10;
            break;

          case 9:
            _context.t0 = null;

          case 10:
            leftItems = _context.t0;

            if (!rightItemsNode) {
              _context.next = 17;
              break;
            }

            _context.next = 14;
            return rehydrateChildren(rightItemsNode);

          case 14:
            _context.t1 = _context.sent;
            _context.next = 18;
            break;

          case 17:
            _context.t1 = null;

          case 18:
            rightItems = _context.t1;
            rehydratedProps = {
              leftItems: leftItems,
              rightItems: rightItems
            };
            return _context.abrupt("return", _react2.default.createElement(_GlobalHeader2.default, rehydratedProps));

          case 21:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();